import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import {lightTheme} from './Themes';
import { Design, Develope} from './AllSvgs';


import LogoComponent from '../subComponents/LogoComponent';
import SocialIcons from '../subComponents/SocialIcons';
import PowerButton from '../subComponents/PowerButton';
import ParticleComponent from '../subComponents/ParticleComponent';
import BigTitle from '../subComponents/BigTitlte'

const Box = styled.div`
background-color: ${props => props.theme.body};
width: 100vw;
height:100vh;
position: relative;
display: flex;
justify-content: space-evenly;
align-items: center;
  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
  }
`

const Main = styled.div`
border: 2px solid ${props => props.theme.text};
color: ${props => props.theme.text};
background-color: rgba(252, 246, 244, 0.25);
padding: 2rem;
width: 30vw;
height: 60vh;
z-index:3;
line-height: 1.5;
cursor: pointer;

font-family: 'Ubuntu Mono',monospace;
display: flex;
flex-direction: column;
justify-content: space-between;

&:hover{
    color: ${props => props.theme.body};
    background-color: ${props => props.theme.text};
}
     @media (max-width: 768px) {
    width: 40vw;
    height: auto;
    padding: 1.5rem;
    margin-top: 3rem;

  }
`

const Title = styled.h2`
display: flex;
justify-content: center;
align-items: center;
font-size: calc(1em + 1vw);

${Main}:hover &{
    &>*{
        fill:${props => props.theme.body};
    }
}

&>*:first-child{
margin-right: 1rem;
}

`

const Description = styled.div`
color: ${props => props.theme.text};
font-size: calc(0.6em + 1vw);
padding: 0.5rem 0;


${Main}:hover &{
   
        color:${props => props.theme.body};
    
}

strong{
    margin-bottom: 1rem;
    text-transform: uppercase;
}
ul,p{
    margin-left: 2rem;
}
 @media (max-width: 768px) {
    font-size: calc(0.4em + 1vw);
    margin-left: 0;
  }
`

const MySkillsPage = () => {
    return (
        <ThemeProvider theme={lightTheme}>
<Box>

<LogoComponent theme='light'/>
<SocialIcons theme='light'/>
<PowerButton />
<ParticleComponent theme='light' />
<Main>
<Title>
    <Develope width={40} height={40} /> Software Developer
</Title>
<Description>
I enjoy writing clean code and creating useful products.
</Description>
<Description>
<strong>I like to code in</strong>
<p>
Python,Javascript, Node, MySQL, C etc.
</p>
</Description>
<Description>
<strong>Tools</strong>
{/* <p>
VScode, Github, Codepen etc.
</p> */}
<ul>
    <li>
        VScode
    </li>
    <li>
       Pycharm
    </li>
    <li>
       CodeBlocks
    </li>
</ul>
</Description>

            </Main>

            <Main>
<Title>
    <Design width={40} height={40} /> Frontend Developer
</Title>
<Description>
I value business or brand for which i'm creating, thus i enjoy bringing new ideas to life.
</Description>
<Description>
<strong>Skills</strong>
{/* <ul>
    <li>
        Web Design
    </li>
    <li>
        Mobile Apps
    </li>
</ul> */}
<p>
Html, Css, Js, React etc.
</p>

</Description>
<Description>
<strong>Tools</strong>
<ul>
    <li>
    VScode, Github etc.
    </li>
    
</ul>
</Description>

            </Main>
            
            <BigTitle text="SKILLS" top="80%" right="30%" />

        </Box>

        </ThemeProvider>
        
    )
}

export default MySkillsPage
